/* Verona Tempo — round 14: the small "More" menu in the header.
   See REVAMP-LOG.md "Smaller footer, links in the navbar, consistent product photo framing".
   Runs after vt-theme.js / vt-r10.js / vt-r12.js (deferred scripts run in page order).

   The same rules as the other menus (round 12):
   - on a computer with a mouse the panel opens only when the pointer RESTS on the button for a moment (120 ms)
     and closes 250 ms after the pointer has left both the button and the panel;
   - a click or a tap opens and closes it (a click right after the hover opened it does not close it again);
   - the keyboard works on its own: Enter or Space opens, ArrowDown goes into the list, Tab walks through it,
     Tab past the last link or Esc closes it and gives the focus back to the button;
   - a click anywhere outside closes it;
   - it is a normal list, so right-to-left, screen readers and "open in a new tab" all behave. */
(function () {
  'use strict';
  var html = document.documentElement;
  var onReady = function (fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  };

  function initMore() {
    var wraps = Array.prototype.slice.call(document.querySelectorAll('[data-vt-more]'));
    if (!wraps.length) return;
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1024px)');
    var OPEN_DELAY = 120;
    var CLOSE_DELAY = 250;

    wraps.forEach(function (wrap) {
      var btn = wrap.querySelector('.vt-more__btn');
      var panel = wrap.querySelector('.vt-more__panel');
      if (!btn || !panel) return;
      var openTimer = 0, closeTimer = 0, openedAt = 0;
      var links = function () {
        return Array.prototype.filter.call(panel.querySelectorAll('a[href]'), function (a) { return a.offsetParent !== null; });
      };
      var isOpen = function () { return wrap.classList.contains('is-open'); };
      var open = function () {
        window.clearTimeout(closeTimer);
        if (isOpen()) return;
        // close any other one first
        wraps.forEach(function (w) { if (w !== wrap) w.classList.remove('is-open'); });
        wrap.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        openedAt = Date.now();
      };
      var close = function (giveFocusBack) {
        window.clearTimeout(openTimer);
        if (!isOpen()) return;
        wrap.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        if (giveFocusBack) btn.focus();
      };

      // ---- pointer: rest to open, a moment of grace to close
      wrap.addEventListener('mouseenter', function (e) {
        if (!e.isTrusted || !canHover.matches) return;
        window.clearTimeout(closeTimer);
        openTimer = window.setTimeout(open, OPEN_DELAY);
      });
      wrap.addEventListener('mouseleave', function (e) {
        if (!e.isTrusted || !canHover.matches) return;
        window.clearTimeout(openTimer);
        closeTimer = window.setTimeout(function () {
          if (wrap.contains(document.activeElement) && document.activeElement !== document.body) return;
          close(false);
        }, CLOSE_DELAY);
      });

      // ---- click / tap / Enter / Space (a real <button>, so the keyboard sends a click too)
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var justOpened = Date.now() - openedAt < 600;
        if (isOpen() && !(e.detail > 0 && justOpened)) close(false);
        else open();
      });

      // ---- keyboard inside the menu
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || (e.key === 'Tab' && !e.shiftKey && isOpen())) {
          var go = function () { var l = links(); if (l.length) { l[0].focus(); } };
          if (!isOpen()) { open(); e.preventDefault(); window.setTimeout(go, 60); }
          else if (e.key === 'ArrowDown') { e.preventDefault(); go(); }
        } else if (e.key === 'Escape') {
          close(true);
        }
      });
      panel.addEventListener('keydown', function (e) {
        var l = links();
        if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          var i = l.indexOf(document.activeElement);
          if (i < 0) return;
          e.preventDefault();
          var next = e.key === 'ArrowDown' ? l[i + 1] : l[i - 1];
          if (next) next.focus(); else if (e.key === 'ArrowUp') btn.focus();
          return;
        }
        if (e.key !== 'Tab' || !l.length) return;
        if (!e.shiftKey && document.activeElement === l[l.length - 1]) close(false);
        else if (e.shiftKey && document.activeElement === l[0]) { e.preventDefault(); close(true); }
      });

      // ---- a click anywhere else closes it
      document.addEventListener('click', function (e) {
        if (!isOpen() || !e.target.closest) return;
        if (e.target.closest('[data-vt-more]') === wrap) return;
        close(false);
      });
      // the page moving away under an open menu (a tap on a link, the back button)
      window.addEventListener('pagehide', function () { close(false); });
    });
    html.classList.add('vt-r14-more-js');
  }

  onReady(function () {
    try { initMore(); } catch (e) { if (window.console) console.warn('vt-r14', e); }
  });
})();
